import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllStamps = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataStamps, setDataStamps] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllStamps, setLoadingFetchAllStamps ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-stamps`)
            console.log('[useFetchData][useFetchAllStamps] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllStamps(true)
        fetchData()
            .then((resp) => {
                setDataStamps(resp.rows)
                setLoadingFetchAllStamps(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllStamps(false)
            })
    }, [execute])

    return { dataStamps, loadingFetchAllStamps, executeFetch }

}

export const useFetchSpecificStamp = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificStamp, setLoadingFetchSpecificStamp ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idstamp: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-specific-stamp/${paramsToSearch.idstamp}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idstamp > 0 ){
            setLoadingFetchSpecificStamp(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idstamp: rows[0].idstamp || '',
                        type_stamp: rows[0].type_stamp || '',
                        amount: rows[0].amount || '',
                        stock: rows[0].stock || ''
                    }))
                    setLoadingFetchSpecificStamp(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificStamp(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificStamp, setParamsToSearch, executeFetch }

}